import React, { Fragment, useEffect } from 'react'
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider
} from '@mui/material'
import {
  Business as BusinessIcon,
  LocationOn as LocationIcon,
  Code as CodeIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Description as DescriptionIcon
} from '@mui/icons-material'
import { Warehouse } from '../../../interfaces/Warehouse/Warehouse'
import { getWarehouseById } from '../config/api'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../../components/UI'
import SignpostIcon from '@mui/icons-material/Signpost'

interface ViewWarehouseModalProps {
  warehouseId: number
  handleSnackbar: (message: string, success: boolean) => void
}

export const ViewWarehouseModal: React.FC<ViewWarehouseModalProps> = ({
  warehouseId,
  handleSnackbar
}) => {
  const { state, callApi } = useApi<Warehouse>()

  const requestWarehouse = () => {
    callApi(getWarehouseById(warehouseId))
      .then(() => {})
      .catch((error) => {
        handleSnackbar(error, false)
      })
  }

  useEffect(() => {
    requestWarehouse()
  }, [])

  if (state.status === Status.Loading)
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )

  return (
    <Fragment>
      <List>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <BusinessIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Nombre Almacén'
            secondary={state.data?.warehouseName}
          />
        </ListItem>

        <Divider variant='inset' component='li' />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <CodeIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Código'
            secondary={state.data?.warehouseCode}
          />
        </ListItem>

        <Divider variant='inset' component='li' />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <LocationIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Dirección'
            secondary={state.data?.warehouseAddress}
          />
        </ListItem>

        <Divider variant='inset' component='li' />
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <DescriptionIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Descripción'
            secondary={state.data?.warehouseDescription}
          />
        </ListItem>

        <Divider variant='inset' component='li' />
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <SignpostIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Código Postal'
            secondary={state.data?.postalCode}
          />
        </ListItem>

        <Divider variant='inset' component='li' />
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              {state.data?.active ? <CheckCircleIcon /> : <CancelIcon />}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Estado'
            secondary={state.data?.active ? 'Activo' : 'Inactivo'}
          />
        </ListItem>
      </List>
    </Fragment>
  )
}
